export default {
  badge: 'Nişan',
  open: 'Açıq',
  close: 'Bağla',
  dismiss: 'Rədd et',
  confirmEdit: {
    ok: 'OK',
    cancel: 'İmtina',
  },
  dataIterator: {
    noResultsText: 'Uyğun məlumat tapılmadı',
    loadingText: 'Yüklənir... Zəhmət olmasa, gözləyin.',
  },
  dataTable: {
    itemsPerPageText: 'Səhifə başı sətir sayı:',
    ariaLabel: {
      sortDescending: 'Azalan sıra ilə düzülmüş.',
      sortAscending: 'Artan sıra ilə düzülmüş.',
      sortNone: 'Sıralanmamışdır.',
      activateNone: 'Sıralamanı yığışdır.',
      activateDescending: 'Azalan sıra ilə düz.',
      activateAscending: 'Artan sıra ilə düz.',
      selectRow: 'Sıra seç',
      selectAll: 'Hamısını seç',
      selectGroup: 'Qrupu seç',
    },
    sortBy: 'Sırala',
  },
  dataFooter: {
    itemsPerPageText: 'Səhifə başı sətir sayı:',
    itemsPerPageAll: 'Hamısı',
    nextPage: 'Növbəti səhifə',
    prevPage: 'Əvvəlki səhifə',
    firstPage: 'İlk səhifə',
    lastPage: 'Son səhifə',
    pageText: '{0} - {1} arası, Cəmi: {2} qeydiyyat',
  },
  dateRangeInput: {
    divider: 'ilə',
  },
  monthPicker: {
    title: 'Ayı seçin',
    itemsSelected: '{0} seçilib',
    header: 'Ayı daxil edin',
    range: {
      title: 'Ayları daxil edin',
    },
    ariaLabel: {
      previousYear: 'Əvvəlki il',
      nextYear: 'Növbəti il',
      selectYear: 'İli seçin',
      currentMonth: 'Cari ay, {0}',
    },
  },
  datePicker: {
    itemsSelected: '{0} seçilib',
    range: {
      title: 'Tarixləri seçin',
      header: 'Tarixləri daxil edin',
    },
    title: 'Tarixi seçin',
    header: 'Tarixi daxil edin',
    input: {
      placeholder: 'Tarixi daxil edin',
    },
    ariaLabel: {
      previousMonth: 'Əvvəlki ay',
      nextMonth: 'Növbəti ay',
      selectYear: 'İli seçin',
      previousYear: 'Əvvəlki il',
      nextYear: 'Növbəti il',
      selectMonth: 'Ayı seçin',
      selectDate: '{0}',
      currentDate: 'Bu gün, {0}',
    },
  },
  noDataText: 'Heç bir məlumat yoxdur.',
  carousel: {
    prev: 'Əvvəlki görüntü',
    next: 'Növbəti görüntü',
    ariaLabel: {
      delimiter: 'Galereya səhifə {0} / {1}',
    },
  },
  calendar: {
    moreEvents: '{0} ədəd daha',
    today: 'Bu gün',
  },
  heatmap: {
    less: 'Az',
    more: 'Çox',
  },
  input: {
    clear: 'Təmizlə {0}',
    prependAction: '{0} qabaqcıl əməliyyat',
    appendAction: '{0} sonrakı əməliyyat',
    otp: 'OTP daxil et {0}',
  },
  fileInput: {
    counter: '{0} fayl',
    counterSize: '{0} fayl (cəmi {1})',
  },
  fileUpload: {
    title: 'Faylları buraya sürüşdürün',
    divider: 'və ya',
    browse: 'Fayllara baxın',
  },
  timePicker: {
    am: 'Səhər',
    pm: 'Axşam',
    title: 'Vaxtı seçin',
    hour: 'Saat',
    minute: 'Dəqiqə',
    second: 'Saniyə',
    notAllowed: 'Dəyərə icazə verilmir',
  },
  pagination: {
    ariaLabel: {
      root: 'Səhifələmə Naviqasiyası',
      next: 'Növbəti səhifə',
      previous: 'Əvvəlki səhifə',
      page: 'Səhifəyə get {0}',
      currentPage: 'Cari səhifə, Səhifə {0}',
      first: 'İlk səhifə',
      last: 'Son səhifə',
    },
  },
  stepper: {
    next: 'Növbəti',
    prev: 'Əvvəlki',
  },
  rating: {
    ariaLabel: {
      item: 'Reytinq {0}/{1}',
    },
  },
  loading: 'Yüklənir...',
  infiniteScroll: {
    loadMore: 'Daha çox yüklə',
    empty: 'Daha yoxdur',
  },
  rules: {
    required: 'Bu sahə tələb olunur',
    email: 'Zəhmət olmasa etibarlı bir e-poçt daxil edin',
    number: 'Bu sahə yalnız rəqəmlərdən ibarət ola bilər',
    integer: 'Bu sahə yalnız tam ədədlərdən ibarət ola bilər',
    capital: 'Bu sahə yalnız böyük hərflərdən ibarət ola bilər',
    maxLength: 'Maksimum {0} simvol daxil etməlisiniz',
    minLength: 'Minimum {0} simvol daxil etməlisiniz',
    strictLength: 'Daxil edilən sahənin uzunluğu yanlışdır',
    exclude: '{0} simvoluna icazə verilmir',
    notEmpty: 'Zəhmət olmasa ən azı bir dəyər seçin',
    pattern: 'Yanlış format',
  },
  command: {
    search: 'Əmr yazın və ya axtarış edin...',
  },
  hotkey: {
    then: 'sonra',
    ctrl: 'Ctrl',
    command: 'Command',
    shift: 'Shift',
    alt: 'Alt',
    option: 'Option',
    enter: 'Enter',
    escape: 'Escape',
    upArrow: 'Yuxarı Ox',
    downArrow: 'Aşağı Ox',
    leftArrow: 'Sol Ox',
    rightArrow: 'Sağ Ox',
    backspace: 'Geri Sil',
    space: 'Boşluq',
    plus: 'plus',
    shortcut: 'Klaviatura qısayolu: {0}',
    or: 'və ya',
  },
  video: {
    play: 'Oynat',
    pause: 'Pauza',
    seek: 'Axtar',
    volume: 'Səs',
    showVolume: 'Səs səviyyəsini göstər',
    mute: 'Səsi kəs',
    unmute: 'Səsi aç',
    enterFullscreen: 'Tam ekran',
    exitFullscreen: 'Tam ekrandan çıx',
  },
  colorPicker: {
    ariaLabel: {
      eyedropper: 'Ekrandan rəng seçin',
      hueSlider: 'Rəng çaları',
      alphaSlider: 'Alfa',
      redInput: 'Qırmızı',
      greenInput: 'Yaşıl',
      blueInput: 'Mavi',
      alphaInput: 'Alfa',
      hueInput: 'Rəng çaları',
      saturationInput: 'Doyğunluq',
      lightnessInput: 'Açıqlıq',
      hexInput: 'HEX dəyəri',
      hexaInput: 'Alfa dəyəri ilə HEX',
      changeFormat: 'Rəng formatını dəyişdirin',
    },
  },
}
